import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IotCo2Service {
  private readonly _URL = 'ws://192.168.104.89:8085/ws/topic/EMCO2';
  // private readonly _URL = 'ws://192.168.104.89:8085/ws/topic/chirpstack';
  private webSocket!: WebSocket;
  private sensorDataSubject: Subject<any> = new Subject<any>();

  constructor() {
    // this.connectWebSocket();
  }

  private connectWebSocket(): void {
    this.webSocket = new WebSocket(this._URL);

    this.webSocket.onmessage = (e) => {
      console.log("SENSORES EM310");
      const data = JSON.parse(e.data);
      
      if (data) {
        this.sensorDataSubject.next(data);
        console.log(data);
      }
    };

    this.webSocket.onclose = (e) => {
      console.log("Conexión cerrada");
    };
  }

  public getDataSensor(): Observable<any> {
    return this.sensorDataSubject.asObservable();
  }
}